import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchPage, updatePagesToRender } from 'actions/pages';
import { createEditorSession, otpResend, submitContactForm, submitOtpForm } from 'actions/editor';
import { fetchGating, resetGating } from 'actions/gating';
import { fetchMappingsForContentGrid, updateFiltersInContenGrid, resetFiltersInContenGrid, updateQueryInContenGrid } from 'actions/contentGrid';
import { fetchPreviewForAsset } from 'actions/content';
import { fetchCustomFields } from 'actions/fields/fields';

import { LIVE_ELEMENT, PAGE, SLIDE } from 'constants/widgetTypes';

import _ from 'lodash';
import cx from 'classnames';
import shortid from 'shortid';
import { ParallaxProvider } from "react-scroll-parallax";

import { Route, Switch, useRouteMatch, useParams, useHistory } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

import { Button, ButtonGroup, OverlayTrigger, Popover, Dropdown } from 'react-bootstrap';
import Device from 'components/Device';
import {
  InteractiveContent, LandingPage, Widgets, SpatialContent,
  BrandThemeManager,
  Fonts, GatingManager
} from '@paperflite-marketing/cleverstory-commons';

import { registerEditorSessionReducer, useEditorSession } from 'components/Editor/hooks/useEditorSession';
import { useMediaQuery } from 'react-responsive';

import { getBaseUrl } from 'services/util';

import '@paperflite-marketing/asset-viewer/dist/index.css';
import 'video.js/dist/video-js.min.css';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import styles from './preview.module.scss';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_PREVIEW } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';

const production = process.env.REACT_APP_DEVELOPMENT === 'false';
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export function PreviewPage() {
  const dispatch = useDispatch();
  const history  = useHistory();
  
  let { path, url } = useRouteMatch();
  let { id } = useParams();
  const iframe = document.getElementById("cs-preview-iframe");

  const [device, setDevice] = useState('none');
  const [state, setState] = useState({
    gatingConfigs: [],
    configuration: null
  })

  const [icons, setIcons] = useState({
    primary: true,
    secondary: true
  })

  const handleDeviceLayout = (type) => {
    setDevice(type)
  }

  useEffect(()=>{
    if(device == 'none' || device == 'tabletls') {
      setIcons((state)=> {
        return {
          primary: device === 'none',
          secondary: true
        }
      })
      return;
    }
    setIcons((state)=> {
      return {
        primary: true,
        secondary: device === 'mobile' 
      }
    })
  },[device])

  const handleMessage = (e) => {
    switch (e.data.type) {
      case 'cleverstory:gating:configs': {
        var gatingConfigs = _.get(e, 'data.payload.gatingConfigs', []);
        setState(state => {
          return {
            ...state,
            gatingConfigs: gatingConfigs
          }
        });

        break;
      }

      case 'cleverstory:gating:closed': {
        setState(state => {
          return {
            ...state,
            configuration: null
          }
        });

        break;
      }
    }
  }

  const handleSelectGating = (gatingConfig) => {
    if (iframe) {
      iframe.contentWindow.postMessage({
        type: 'cleverstory:gating:preview',
        payload: {
          page: id,
          configuration: gatingConfig
        }
      }, '*');

      setState(state => {
        return {
          ...state,
          configuration: gatingConfig
        }
      })
    }
  }

  const handleCloseGating = () => {
    if (iframe) {
      iframe.contentWindow.postMessage({
        type: 'cleverstory:gating:closed',
        payload: {
          page: id,
          configuration: state.configuration
        }
      }, '*');

      setState(state => {
        return {
          ...state,
          configuration: null
        }
      })
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage);
    }
  }, [])

  return (
    <div className={styles.preview}>
      <Device className={cx(styles.devices, styles[device])} mode={device}>
        <iframe key={device} id='cs-preview-iframe' src={`${url}/embedded`}></iframe>
      </Device>

      <ButtonGroup className={styles.devicesSwitcher}>
        {state.configuration &&
          <Button className={styles.closeGating} onClick={handleCloseGating}>
            <FontAwesomeIcon icon={faWindowClose} />
          </Button>
        }
        {state.gatingConfigs && state.gatingConfigs.length > 0 &&
          <Dropdown className={styles.gatingButtonDropdown}>
            <Dropdown.Toggle variant="Secondary" id="dropdown-basic">
              <i className={cx("cleverstory-lock", styles.icon)} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Header>
                <h4 className={styles.header}>PREVIEW GATING</h4>
              </Dropdown.Header>
              {state.gatingConfigs.map((item, index) => {
                let gating = _.get(item, 'gating', null);
                if(!gating) {
                  return;
                }
                return <Dropdown.Item key={index} onClick={() => handleSelectGating(item)}>{gating.name}</Dropdown.Item>
              })}
            </Dropdown.Menu>
          </Dropdown>
        }
        <span className={styles.layoutOptions}>
          <Button id='primary' className={cx({ [styles.active]: (device == 'none' || device == 'tabletls') })} 
            onClick={()=>handleDeviceLayout(device === 'none' ? 'tabletls' : 'none')}
            onMouseEnter={()=> {
              if(device == 'none' || device == 'tabletls'){
              setIcons((state)=>{
              return {
                ...state,
                primary: !state.primary 
              }})
            }}}
            onMouseLeave={()=> {
              if(device == 'none' || device == 'tabletls'){
                setIcons((state)=>{
                return {
                  ...state,
                  primary: device == 'none' 
                }})
              }}}
            >
            {icons.primary  && <i className={cx("cleverstory-laptop", styles.icon)} />}
            {!icons.primary  && <i className={cx("cleverstory-tablet-ls", styles.icon)} />}
          </Button>

          <Button id='secondary' className={cx({ [styles.active]: (device == 'mobile' || device == 'tablet') })} 
            onClick={()=>handleDeviceLayout(device === 'mobile' ? 'tablet' : 'mobile')}
            onMouseEnter={()=> {
              if(device == 'mobile' || device == 'tablet'){
              setIcons((state)=>{
              return {
                ...state,
                secondary: !state.secondary 
              }})
            }}}
            onMouseLeave={()=> {
              if(device == 'mobile' || device == 'tablet'){
                setIcons((state)=>{
                return {
                  ...state,
                  secondary: device == 'mobile' 
              }})
            }}}
            >
            {icons.secondary && <i className={cx("cleverstory-mobile", styles.icon)} /> }
            {!icons.secondary &&  <span className={styles.rotate}><i className={cx("cleverstory-tablet-ls", styles.icon)}/> </span>}
          </Button>
        </span>
      </ButtonGroup>

    </div>
  );
}

export function EmbeddedPageView(props) {
  const dispatch = useDispatch();

  const { id } = useParams();

  const editorRef = React.useRef(`editors_${id}`);

  const page = useSelector((state) => _.get(state, `pages.page.${id}.item`));
  const pageId = _.get(page, "id");
  const pageLoaded = _.get(page, "id") != null;

  const storyboard = _.get(page, 'storyboard', null);
  const storyboardId = _.get(storyboard, 'id', '');
  const storyboardName = _.get(storyboard, 'name', '');
  const storyboardType = _.get(storyboard, 'type', '');
  const appearance = _.get(storyboard, 'appearance', null);

  useEffect(() => {
    if(pageLoaded){
      var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_PREVIEW, storyboardId, storyboardName, storyboardType)
      dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))
    }
  }, [pageLoaded]);

  useEffect(() => {
    editorRef.current = `editors_${id}`;

    dispatch(fetchPage(id, true));
  }, [id]);

  if(!pageLoaded) {
    return null;
  }

  return storyboardType === 'SPATIAL' ? 
    <SpatialPageView 
      appearance={appearance} 
      pageId={pageId} 
      storyboard={storyboard}
    /> : 
    <PageView 
      pageId={pageId} 
      storyboard={storyboard}
    />
}

export const PageView = ({ pageSummary, pageId, storyboard, children }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const editorRef = React.useRef(`editors_${shortid()}`);
  const editorSession = useEditorSession(editorRef.current);
  const gatingContext = React.useContext(Widgets.GatingContext);
  const gatingRef = React.useRef(null);

  const [widgetContextState, setWidgetContextState] = useState({
    selector: ''
  });
  const [selectedDomain, setSelectedDomain] = useState({})

  const [formContextState, setFormContextState] = useState({
    onFormSubmit: () => { },
    onOtpFormSubmit: () => { },
    onOtpResend: () => { }
  });

  const [windowHeight, setWindowHeight] = useState('100vh');

  const page = useSelector((state) => _.get(state, `pages.page.${pageId}.item`));
  const pageLoaded = _.get(page, "id") != null;

  const appearance = _.get(storyboard, 'appearance', null);
  const storyboardType = _.get(storyboard, 'type', '');

  const gatingConfigurations = useSelector(state => _.get(state, `pages.page.${pageId}.item.gatings`, []));
  var domain = useSelector(state => _.get(state, 'workspaces.workspace.item.defaultDomain') || "");

  const pageWidgets = useSelector((state) => {
    const widgets = _.get(state, `${widgetContextState.selector}.widgets`) || [];
    var pageSections = widgets.filter(item => {
      return item.type === PAGE;
    });

    pageSections = _.sortBy(pageSections, 'order');

    return pageSections;
  });

  const fonts = useSelector(state => _.get(state, `pages.page.${pageId}.item.draft.fonts`) || []);
  Fonts.useFont(fonts);

  const desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });

  useEffect(() => {
    if (editorRef.current && pageLoaded) {
      const widgets = _.get(page, "draft.widgets") || [];

      var activePage = null;
      var pageSections = widgets.filter(item => {
        return item.type === PAGE;
      });

      pageSections = _.sortBy(pageSections, 'order');

      if (_.size(pageSections) > 0) {
        activePage = pageSections[0].uid;
      }

      const initialState = {
        widgets: widgets,
        interactive: {
          active: activePage
        }
      }

      dispatch(createEditorSession(editorRef.current, initialState));

      setWidgetContextState({
        session: editorRef.current,
        selector: `${editorRef.current}.present`,
        breakpoint: desktop ? 'desktop' : 'mobile',
        imageCDN: IMAGE_CDN_ENDPOINT,
        shouldZoom: true,
        preview: true,
        development: false,
        domain: _.get(selectedDomain, 'url'),
        createLiveElementContext: (element) => {
          const sessionId = `editors_live_element_${element.uid}`;

          return {
            ...widgetContextState,
            session: sessionId,
            selector: `${sessionId}.present`
          }
        },
        createGatingContext: (gating) => {
          const sessionId = `editors_gating_${gating}`;

          return {
            ...widgetContextState,
            session: sessionId,
            selector: `${sessionId}.present`
          }
        },
        fetchGating: (gating) => {
          dispatch(fetchGating(gating, true))
        },
        fetchPage: (id) => {
          dispatch(fetchPage(id, true));
        }
      });

      setFormContextState({
        onFormSubmit: handleFormSubmit,
        onOtpFormSubmit: handleOtpFormSubmit,
        onOtpResend: handleOtpResend
      });

      widgets.filter(item => item.type === LIVE_ELEMENT).forEach(item => {
        const sessionId = `editors_live_element_${item.uid}`;
        registerEditorSessionReducer(sessionId);
        dispatch(createEditorSession(sessionId, {
          widgets: item.children
        }));
      });
    }
  }, [editorRef.current, pageLoaded]);

  useEffect(() => {
    setWidgetContextState((state) => {
      return {
        ...state,
        domain: _.get(selectedDomain, 'url'),
        breakpoint: desktop ? 'desktop' : 'mobile'
      }
    });
  }, [desktop, selectedDomain]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    }
  }, []);

  useEffect(() => {
    if (storyboard) {
      setWidgetContextState((state) => {
        return {
          ...state,
          domain: _.get(selectedDomain, 'url'),
          storyboard: storyboard
        }
      });

      dispatch(fetchCustomFields(_.get(storyboard, 'id')))
    }

    let domainUrl = _.get(storyboard, 'domain') || domain;
    setSelectedDomain(domainUrl);
  }, [storyboard]);

  useEffect(() => {
    if (gatingConfigurations && gatingConfigurations.length > 0) {

      gatingConfigurations.forEach(item => {
        let gating = _.get(item, 'gating.id', null);
        if (gating) {
          dispatch(fetchGating(gating, true))
        }
      })

      window.parent.postMessage({
        type: "cleverstory:gating:configs",
        payload: {
          page: pageId,
          gatingConfigs: gatingConfigurations
        }
      }, '*');
    }
  }, [gatingConfigurations]);

  useEffect(() => {
    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage);
    }
  }, []);

  const handleChange = (type, data) => {
    if (type === 'index') {
      //console.log("Current page -" + data.index);
    } else if (type === 'progress') {
      //console.log(`Page ${data.index} - progress ${data.progress}`);
    }
  }

  const handleFormSubmit = (editorSession, formId, fields) => {
    dispatch(submitContactForm(editorSession, formId));
  }

  const handleOtpFormSubmit = (editorSession, formId, fields) => {
    dispatch(submitOtpForm(editorSession, formId));
  }

  const handleOtpResend = (editorSession, formId, fields) => {
    dispatch(otpResend(editorSession, formId));
  }

  const handleWindowResize = () => {
    const height = window.innerHeight;
    setWindowHeight(`${height}px`);
  }

  const handleResetGating = (page) => {
    window.parent.postMessage({
      type: "cleverstory:gating:closed",
      payload: {
        page: pageId
      }
    }, '*');
  }

  const handleMessage = (e) => {
    switch (e.data.type) {
      case 'cleverstory:gating:preview': {
        var configuration = _.get(e, 'data.payload.configuration', null);
        if (configuration) {
          gatingRef.current.triggerGating('PREVIEW', null, configuration);
        }

        break;
      }

      case 'cleverstory:gating:closed': {
        var configuration = _.get(e, 'data.payload.configuration', null);
        gatingRef.current.closeGating(configuration);

        break;
      }
    }
  }

  return (
    <div key={widgetContextState.breakpoint} className={styles.content}>
      <style>
        {`
          :root{
            --window-height: ${windowHeight};
          }
        `}
      </style>

      <BrandThemeManager className={".cs_text_widget"} themes={_.get(storyboard, 'themes')} />

      <Widgets.Context.Provider value={widgetContextState}>
        <Widgets.FormContext.Provider value={formContextState}>
          <GatingManager ref={gatingRef}
            configurations={gatingConfigurations}
            resetGating={handleResetGating}
            page={pageId}
            breakpoint={widgetContextState.breakpoint}
            preview>
            <Widgets.Content.Manager
              debug={!production}
              fetchMappingsForContentGrid={(contentGrid, page, limit) => {
                dispatch(fetchMappingsForContentGrid(editorSession.id, contentGrid, page, limit, true));
              }}
              fetchPreviewDataForAsset={(asset) => {
                dispatch(fetchPreviewForAsset(asset));
              }}
              updateFiltersInContenGrid={(contentGrid, filters) => {
                dispatch(updateFiltersInContenGrid(editorSession.id, contentGrid, filters));
              }}
              updateQueryInContenGrid={(contentGrid, query) => {
                dispatch(updateQueryInContenGrid(editorSession.id, contentGrid, query));
              }}
              resetFiltersInContenGrid={(contentGrid) => {
                dispatch(resetFiltersInContenGrid(editorSession.id, contentGrid));
              }}
              onContentChange={(content) => {
                const url = _.get(content, 'content.alias');
                const name = _.get(content, 'content.name');
                window.history.replaceState(null, name, url);
              }}
              onAnalyticsChange={(asset, analytics) => {

              }}
              onDownload={(asset) => {
                console.log(`Download Asset ${asset.id}`);
              }}
              onClose={() => {
                console.log("Close Dialog");
              }}
            >
              <Widgets.Actions.Provider value={{
                onBeforeExecution: () => { }
              }}>
                {storyboardType === 'INTERACTIVE_CONTENT' &&
                  <InteractiveContent initialPage={0} appearance={appearance} onChange={handleChange}>
                    {pageWidgets.map((widget, index) => {
                      return <Widgets.Widget key={widget.uid} widgetProps={widget} breakpoint={widgetContextState.breakpoint} />
                    })}
                  </InteractiveContent>
                }

                {["LANDING_PAGE", "RESOURCE_CENTER"].includes(storyboardType) &&
                  <LandingPage onChange={handleChange} pageWidgets={pageWidgets}>
                    {pageWidgets.map((widget, index) => {
                      return <Widgets.Widget key={widget.uid} widgetProps={widget} breakpoint={widgetContextState.breakpoint} />
                    })}
                  </LandingPage>
                }

                {storyboardType === 'SPATIAL' && 
                  <SpatialPageRender appearance={appearance} page={page ? page : pageSummary} pageId={pageId} />
                }
              </Widgets.Actions.Provider>
            </Widgets.Content.Manager>
          </GatingManager >
        </Widgets.FormContext.Provider>
      </Widgets.Context.Provider>
    </div>
  );
}

const PAGES_TO_LOAD = 4;

export const SpatialPageView = ({ pageId, appearance, storyboard }) => {
  const dispatch = useDispatch();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const pages = useSelector(state => _.get(state, `pages.spatial.items`, []));
  const pagesToRender = useSelector(state => _.get(state, `pages.spatial.pagesToRender`, []));

  const desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });


  const handleChange = (type, data) => {
    if (type === 'index') {
      //console.log("Current page -" + data.index);
    } else if (type === 'progress') {
      //console.log(`Page ${data.index} - progress ${data.progress}`);
    }

    const id = _.get(data, 'activePage.id', null);
    if(id) {
      const currentPage = _.find(pages, { id: id })
      window.history.replaceState(null, currentPage.name, `${baseUrl}/pages/${currentPage.id}/preview/embedded`);
    }
  }

  const handleFetchPage = (page) => {
    dispatch(fetchPage(page, true));
  }

  const handleUpdatePagesToRender = (pages) => {
    dispatch(updatePagesToRender(pages));
  }

  return (
    <SpatialContent appearance={appearance}  pages={pages} 
      imageCDN={IMAGE_CDN_ENDPOINT}
      breakpoint={desktop ? 'desktop' : 'mobile'} 
      initialPage={pageId} 
      onChange={handleChange}
      onFetchPage={handleFetchPage}
      updatePagesToRender={handleUpdatePagesToRender}
      pagesToRender={pagesToRender}
    >
      {pages &&
        pages.map((page, i) => {
          return <PageView key={i} pageId={page.id} pageSummary={page} storyboard={storyboard} />
        })
      }
    </SpatialContent>
  )
}

const SpatialPageRender = ({appearance, page }) => {

  const widgetContext = React.useContext(Widgets.Context);

  const slideWidgets = useSelector((state) => {
    const widgets = _.get(state, `${widgetContext.selector}.widgets`) || [];
    var slides = widgets.filter(item => {
      return item.type === SLIDE;
    });

    slides = _.sortBy(slides, 'order');

    return slides;
  });
  
  const pagesToRender = useSelector(state => _.get(state, `pages.spatial.pagesToRender`, []));
  const loading = useSelector(state => _.get(state, `pages.page[${page.id}].loading`, false));
  const renderPage = pagesToRender.some(id => id === page.id);

  return (
    <ParallaxProvider>
      <SpatialContent.SpatialPage appearance={appearance} page={page} slideWidgets={slideWidgets} loading={loading}>
        {renderPage && slideWidgets.map((widget, index) => {
          return (
            <Widgets.Widget key={widget.uid} widgetProps={widget} breakpoint={widgetContext.breakpoint} />
          )
        })}
      </SpatialContent.SpatialPage>
    </ParallaxProvider>
  )
}